import GemeindeActionTypes from "./gemeinde.types";

export const fetchGemeindeStart = (gemeindeRef) => ({
  type: GemeindeActionTypes.FETCH_GEMEINDE_START,
  payload: gemeindeRef,
});

export const fetchGemeindeSuccess = (gemeindeData) => ({
  type: GemeindeActionTypes.FETCH_GEMEINDE_SUCCESS,
  payload: gemeindeData,
});
export const fetchErntehelferSuccess = (erntehelfer) => ({
  type: GemeindeActionTypes.FETCH_ERNTEHELFER_SUCCESS,
  payload: erntehelfer,
});

export const fetchGemeindeFailure = (errorMessage) => ({
  type: GemeindeActionTypes.FETCH_GEMEINDE_FAILURE,
  payload: errorMessage,
});

export const clearGemeinde = (errorMessage) => ({
  type: GemeindeActionTypes.CLEAR_GEMEINDE,
  payload: errorMessage,
});

export const fetchGemeindelisteStart = () => ({
  type: GemeindeActionTypes.FETCH_GEMEINDELISTE_START,
});

export const fetchGemeindelisteSuccess = (gemeindeliste) => ({
  type: GemeindeActionTypes.FETCH_GEMEINDELISTE_SUCCESS,
  payload: gemeindeliste,
});

export const fetchGemeindelisteFailure = (errorMessage) => ({
  type: GemeindeActionTypes.FETCH_GEMEINDELISTE_FAILURE,
  payload: errorMessage,
});
